import { render, staticRenderFns } from "./RsaPazienteStoricoStatiComponent.vue?vue&type=template&id=0f5dc578"
import script from "./RsaPazienteStoricoStatiComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteStoricoStatiComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports